module.exports = __webpack_public_path__ + "media/applicants/shopper_app_icon-0c824808.png";